import posed, { PoseGroup } from 'react-pose';
import * as React from 'react';
import { Text } from '@gje/typography/lib';
import { Coverage } from '../../../../types/Coverage';
import { HtmlPanel } from '../../HtmlPanel/HtmlPanel';
import useMobile from '../../../../hooks/useMobile';
import classNames from 'classnames';
import useNextRenderCall from '../../../../hooks/useNextRenderCall';
import useScroll from '../../../../hooks/useScroll';
import { Checkbox } from '@gje/forms';
import { numberWithSpaces } from '../../../../utils/stringUtils';
import { resolvePaymentTerm } from '../../../../services/calculation-data/calculation-data-service';

interface TillagsCoverageProps {
    tillagsCoverageData: Coverage;
    isOpen: boolean;
    onClick: Function;
    handleTillagsBuy: Function;
    paymentTerm: number;
    price: number;
}

const Container = posed.li({
    open: {
        delay: 600,
        opacity: 1
    },
    closed: {
        opacity: 0,
        duration: 900
    }
});

const TillagsCoverHelpBox = posed.div({
    exit: {
        height: 0,
        opacity: 0,
        transition: {
            ease: 'easeIn',
            duration: 0
        }
    },
    enter: {
        opacity: 1,
        height: 'auto',
        transition: {
            ease: 'easeIn',
            duration: 300
        }
    }
});

const AdditionalCoverage: React.FunctionComponent<TillagsCoverageProps> = ({
    tillagsCoverageData,
    isOpen,
    handleTillagsBuy,
    paymentTerm,
    price,
    onClick
}) => {
    const isMobile = useMobile();
    const { scroll, ScrollTo } = useScroll();
    const smoothScroll = useNextRenderCall(scroll);

    return (
        <ScrollTo>
            <Container key={tillagsCoverageData.coverageName}>
                <a
                    className={classNames(
                        'no-underline',
                        {
                            green: isMobile && isOpen,
                            'green-on-hover': !isMobile
                        },
                        'display-inline-flex',
                        'align-items',
                        'width-100-percent'
                    )}>
                    <div
                        onClick={e => {
                            onClick(e);
                            if (!isOpen) {
                                smoothScroll();
                            }
                        }}>
                        <Text
                            size={'h6'}
                            className={classNames(
                                'available-cover-disc',
                                'dont-hide-card-click',
                                {
                                    'font-size-10': isMobile
                                }
                            )}>
                            {isOpen ? <>&#9650;</> : <>&#9660;</>}
                        </Text>
                    </div>
                    <Checkbox
                        id={tillagsCoverageData.coverageId.toString()}
                        label=""
                        name={tillagsCoverageData.coverageName}
                        value={tillagsCoverageData.coverageName}
                        checked={tillagsCoverageData.selected}
                        onChange={() => {
                            handleTillagsBuy(tillagsCoverageData.coverageId);
                        }}
                    />
                    <div
                        onClick={e => {
                            onClick(e);
                            if (!isOpen) {
                                smoothScroll();
                            }
                        }}
                        className={classNames(
                            'col-xs-23 no-padding flex-align-center'
                        )}>
                        <div className="col-xs-15 no-padding">
                            <Text
                                size={'h5'}
                                className={classNames(
                                    'white-space-normal dont-hide-card-click flex-align-center'
                                )}>
                                {tillagsCoverageData.coverageName}
                            </Text>
                        </div>
                        <div className="col-xs-8 no-padding">
                            <Text
                                size={'h5'}
                                className={classNames(
                                    'white-space-normal tillags-cover-price flex-align-center'
                                )}>
                                {`${numberWithSpaces(
                                    price
                                )} ${resolvePaymentTerm(
                                    paymentTerm,
                                    price,
                                    true
                                )}`}
                            </Text>
                        </div>
                    </div>
                </a>
                <div className="tillags-list-element">
                    <PoseGroup>
                        {isOpen && [
                            <TillagsCoverHelpBox
                                className={classNames(
                                    'dont-hide-card-click',
                                    isMobile
                                        ? 'mobile-coverage-arrow-box'
                                        : 'coverage-arrow-box'
                                )}
                                key="extraCoverHelpBox">
                                <Text className={'dont-hide-card-click'}>
                                    <HtmlPanel
                                        className={'dont-hide-card-click'}>
                                        {
                                            tillagsCoverageData.coverageDescription
                                        }
                                    </HtmlPanel>
                                </Text>
                            </TillagsCoverHelpBox>
                        ]}
                    </PoseGroup>
                </div>
            </Container>
        </ScrollTo>
    );
};

export default AdditionalCoverage;
